/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { NodeCompat } from '../../../../compat/NodeCompat';
import { Node } from '../../../models/Node';
import { ValidationRule } from '../../ValidationRule';
import { ValidationRuleMetaData } from '../../ValidationRuleMetaData';

/**
 * Constructor.
 * @param {ValidationRuleMetaData} ruleInfo
 * @class
 * @extends ValidationRule
 * @author eric.wittmann@gmail.com
 */
export abstract class RequiredPropertyValidationRule extends ValidationRule {
    public constructor(ruleInfo : ValidationRuleMetaData) {
        super(ruleInfo);
    }

    /**
     * Called when a required property is missing.
     * @param {Node} node
     * @param {string} propertyName
     * @param {*} messageParams
     */
    requireProperty(node : Node, propertyName : string, messageParams : any) {
        let propertyValue : any = NodeCompat.getProperty(node, propertyName);
        if(!this.isDefined(propertyValue)) {
            this.report(node, propertyName, messageParams);
        }
    }

    /**
     * Called when a conditionally required property is missing.
     * @param {Node} node
     * @param {string} propertyName
     * @param {string} dependentPropertyName
     * @param {*} dependentPropertyExpectedValue
     * @param {*} messageParams
     */
    requirePropertyWhen(node : Node, propertyName : string, dependentPropertyName : string, dependentPropertyExpectedValue : any, messageParams : any) {
        let dependentPropertyActualValue : any = NodeCompat.getProperty(node, dependentPropertyName);
        if(NodeCompat.equals(dependentPropertyActualValue, dependentPropertyExpectedValue)) {
            this.requireProperty(node, propertyName, messageParams);
        }
    }
}
RequiredPropertyValidationRule["__class"] = "io.apicurio.datamodels.core.validation.rules.required.RequiredPropertyValidationRule";
RequiredPropertyValidationRule["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




